import { svg } from 'lit';
export const arrowDown24Svg = svg `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 6V18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18 12L12 18L6 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
//# sourceMappingURL=arrow-down_24.svg.js.map